import request from '@/router/axios'

export function fetchList (obj) {
  return request({
    url: '/dotadmin/dotPoint/pointListData',
    method: 'post',
    data: obj
  })
}

export function addObj (obj) {
  return request({
    url: '/dotadmin/dotPoint/saveTrDisableStatus',
    method: 'post',
    data: obj
  })
}

export function exportData (obj) {
  return request({
    url: '/dotadmin/dotPoint/export',// 导出
    method: 'post',
    data: obj,
  })
}

export function saveOneEdit (obj) {
  return request({
    url: '/dotadmin/dotPoint/saveOneEdit',// 导入
    method: 'post',
    data: obj
  })
}

export function getObj (query) {
  return request({
    url: '/dotadmin/dotPoint/logList',
    method: 'post',
    data: query
  })
}

export function putObj (obj) {
  return request({
    url: '/dotadmin/dotPoint',
    method: 'put',
    data: obj
  })
}

export function backupList (query) {
  return request({
    url: '/dotadmin/dotRisk/backupList',
    method: 'post',
    data: query
  })
}

export function checkAddBackUpTr (query) {
  return request({
    url: '/dotadmin/dotRisk/checkAddBackUpTr',
    method: 'post',
    data: query
  })
}

export function qcDisableTrIds (query) {
  return request({
    url: '/dotadmin/dotRisk/qcDisableTrIds',
    method: 'post',
    data: query
  })
}
